import { v4 as uuidv4 } from 'uuid';
import { SET_ALERT, REMOVE_ALERT } from '../types';

export const removeAlert = (id) => async (dispatch) => {
  await dispatch({
    type: REMOVE_ALERT,
    payload: id,
  });
};

export const setAlert = (msg, type) => async (dispatch) => {
  const id = uuidv4();
  await dispatch({
    type: SET_ALERT,
    payload: { msg, type, id },
  });
};
